module.exports = __webpack_public_path__ + "static/media/beverages_GC@3x.80c077f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/beverages_GC@3x.png
// module id = 768
// module chunks = 1